"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.megaSearchSagas = void 0;
var effects_1 = require("redux-saga/effects");
var MegaMenuAction_1 = require("@/pages/common/actions/MegaMenuAction");
var MegaMenuSearchAction_1 = require("@/pages/common/actions/MegaMenuSearchAction");
var WindowApi_1 = require("@/api/browser/WindowApi");
var getKeywordSuggestions_1 = require("@/pages/search/sagas/api/getKeywordSuggestions");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var GetSuggestionApiResponse_1 = require("@/pages/search/states/GetSuggestionApiResponse");
var groupRows_1 = require("@/pages/common/transformers/groupRows");
var LayoutState_1 = require("@/pages/common/states/LayoutState");
var getPartBy_1 = require("@/pages/common/transformers/getPartBy");
var getSuggestionGroups = function (state) { return state.layout.megamenusearch.suggestionGroups; };
var getCurrentGroupIndex = function (state) { return state.layout.megamenusearch.suggestionGroupIndex; };
var getCurrentRowIndex = function (state) { return state.layout.megamenusearch.suggestionRowIndex; };
var getSfilterType = function (state) { return state.layout.megamenusearch.type; };
var getKeyword = function (state) { return state.layout.megamenusearch.keyword; };
var getMegamenuSearchTranslate = function (state) { return state.layout.megamenusearch.t; };
var getSearchPopupType = function (state) { return state.layout.megamenusearch.type; };
var watchMegaMenuSearchIconClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_SEARCH_ICON_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.onSearchIconClicked())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchSearchIconClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MegaMenuSearchAction_1.default.MEGAMENU_SEARCH_ICON_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.setActive(true))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.call(focusFullKeywordFields)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchCloseIconClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(MegaMenuSearchAction_1.default.MEGAMENU_SEARCH_CLOSE_ICON_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.setActive(false))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchBackgroundClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(MegaMenuSearchAction_1.default.MEGAMENU_SEARCH_BACKGROUND_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.setActive(false))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchSearchInputChanged = function () {
    var payload, keyword;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MegaMenuSearchAction_1.default.MEGAMENU_SEARCH_ON_SEARCH_INPUT_CHANGE)];
            case 1:
                payload = (_a.sent()).payload;
                keyword = payload;
                return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.setInput(keyword))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.onAutoComplete(keyword))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var delaySuggestion = function (force) {
    var keywordInput, type, megamenuSearchTranslate, keyword, isChinese, minAutocompleteLength, suggestions, groupedSuggestions;
    if (force === void 0) { force = false; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!!force) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.delay(800)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.setSuggestionGroups([]))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getKeyword)];
            case 4:
                keywordInput = _a.sent();
                return [4 /*yield*/, effects_1.select(getSfilterType)];
            case 5:
                type = _a.sent();
                return [4 /*yield*/, effects_1.select(getMegamenuSearchTranslate)];
            case 6:
                megamenuSearchTranslate = _a.sent();
                keyword = keywordInput.trim();
                return [4 /*yield*/, effects_1.call(WindowApi_1.checkIsChinese, keyword)];
            case 7:
                isChinese = _a.sent();
                minAutocompleteLength = isChinese ? 1 : 3;
                if (keyword.length < minAutocompleteLength)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.setLoading(true))];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.call(getKeywordSuggestions_1.getKeywordSuggestionsByType, keyword, type)];
            case 9:
                suggestions = _a.sent();
                return [4 /*yield*/, effects_1.call(groupRows_1.groupRows, suggestions, megamenuSearchTranslate)];
            case 10:
                groupedSuggestions = _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.setLoading(false))];
            case 11:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.setSuggestionGroups(groupedSuggestions))];
            case 12:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchOnAutoComplete = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.takeLatest(MegaMenuSearchAction_1.default.MEGAMENU_SEARCH_ON_AUTOCOMPLETE, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.call(delaySuggestion)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchSearchButtonClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(MegaMenuSearchAction_1.default.MEGAMENU_SEARCH_SEARCH_BUTTON_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doSearch)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchSearchTypeClick = function () {
    var payload, type, keyword, FORCE;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(MegaMenuSearchAction_1.default.MEGAMENU_SEARCH_ON_TYPE_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                type = payload;
                return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.setType(type))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getKeyword)];
            case 3:
                keyword = _a.sent();
                if (!keyword)
                    return [3 /*break*/, 0];
                FORCE = true;
                return [4 /*yield*/, effects_1.call(delaySuggestion, FORCE)];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var focusFullKeywordFields = function () {
    var elm;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.delay(100)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getSearchInputElement)];
            case 2:
                elm = _a.sent();
                if (!elm) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(WindowApi_1.setElementFocus, elm)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/];
        }
    });
};
var doSearch = function (currentItem) {
    var lang, rawKeyword, keyword, isChinese, minAutocompleteLength, langCode, searchFilterType, searchResultType, searchResultId, url;
    if (currentItem === void 0) { currentItem = null; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguage)];
            case 1:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.select(getKeyword)];
            case 2:
                rawKeyword = _a.sent();
                keyword = currentItem ? getPartBy_1.getPartBy(lang === LayoutState_1.Language.EN_US ? false : true, currentItem.name.split(' | ')) : rawKeyword;
                return [4 /*yield*/, effects_1.call(WindowApi_1.checkIsChinese, keyword)];
            case 3:
                isChinese = _a.sent();
                minAutocompleteLength = isChinese ? 1 : 3;
                if (keyword.length < minAutocompleteLength)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 4:
                langCode = _a.sent();
                return [4 /*yield*/, effects_1.select(getSearchPopupType)];
            case 5:
                searchFilterType = _a.sent();
                searchResultType = currentItem ? currentItem.type : null;
                searchResultId = currentItem ? currentItem.id : null;
                return [4 /*yield*/, effects_1.call(WindowApi_1.getSearchUrlFromKeywordAndSearchResultType, keyword, searchFilterType, searchResultType, searchResultId, langCode)];
            case 6:
                url = _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.setFullscreenLoading(true))];
            case 7:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, url)];
            case 8:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchOnEnter = function () {
    var groupIndex, rowIndex, suggestionGroups, rawKeyword, currentItem;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(MegaMenuSearchAction_1.default.MEGAMENU_SEARCH_ON_KEYWORD_ENTER)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentGroupIndex)];
            case 2:
                groupIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentRowIndex)];
            case 3:
                rowIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getSuggestionGroups)];
            case 4:
                suggestionGroups = _a.sent();
                return [4 /*yield*/, effects_1.select(getKeyword)];
            case 5:
                rawKeyword = _a.sent();
                currentItem = (rowIndex > -1 && groupIndex > -1) ?
                    suggestionGroups[groupIndex].suggestions[rowIndex] :
                    {
                        id: 0,
                        type: GetSuggestionApiResponse_1.GetSuggestionResultType.Keyword,
                        name: rawKeyword
                    };
                return [4 /*yield*/, effects_1.call(doSearch, currentItem)];
            case 6:
                _a.sent();
                return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
var watchOnSuggestionClick = function () {
    var payload, groupIndex, rowIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MegaMenuSearchAction_1.default.MEGAMENU_SEARCH_ON_SUGGESTION_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                groupIndex = payload.groupIndex, rowIndex = payload.rowIndex;
                return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.setSuggestionGroupRowIndex(groupIndex, rowIndex))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.onKeywordEnter())];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchOnKeywordUp = function () {
    var groupIndex, rowIndex, suggestionGroups, nextGroupIndex, nextRowIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(MegaMenuSearchAction_1.default.MEGAMENU_SEARCH_ON_KEYWORD_PREV)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentGroupIndex)];
            case 2:
                groupIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentRowIndex)];
            case 3:
                rowIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getSuggestionGroups)];
            case 4:
                suggestionGroups = _a.sent();
                nextGroupIndex = groupIndex > -1 ? (rowIndex <= 0 ? (groupIndex <= 0 ? suggestionGroups.length - 1 : groupIndex - 1) : groupIndex) : 0;
                nextRowIndex = rowIndex > -1 ? (rowIndex <= 0 ? suggestionGroups[nextGroupIndex].suggestions.length - 1 : rowIndex - 1) : 0;
                return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.setSuggestionGroupRowIndex(nextGroupIndex, nextRowIndex))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchOnKeywordDown = function () {
    var groupIndex, rowIndex, suggestionGroups, nextGroupIndex, nextRowIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(MegaMenuSearchAction_1.default.MEGAMENU_SEARCH_ON_KEYWORD_NEXT)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentGroupIndex)];
            case 2:
                groupIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentRowIndex)];
            case 3:
                rowIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getSuggestionGroups)];
            case 4:
                suggestionGroups = _a.sent();
                nextGroupIndex = groupIndex > -1 ? (rowIndex === suggestionGroups[groupIndex].suggestions.length - 1 ? (groupIndex === suggestionGroups.length - 1 ? 0 : groupIndex + 1) : groupIndex) : 0;
                nextRowIndex = rowIndex > -1 ? (rowIndex === suggestionGroups[groupIndex].suggestions.length - 1 ? 0 : rowIndex + 1) : 0;
                return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.setSuggestionGroupRowIndex(nextGroupIndex, nextRowIndex))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var megaSearchSagas = {
    watchMegaMenuSearchIconClick: watchMegaMenuSearchIconClick,
    watchSearchIconClick: watchSearchIconClick,
    watchCloseIconClick: watchCloseIconClick,
    watchBackgroundClick: watchBackgroundClick,
    watchSearchInputChanged: watchSearchInputChanged,
    watchSearchButtonClick: watchSearchButtonClick,
    watchSearchTypeClick: watchSearchTypeClick,
    watchOnAutoComplete: watchOnAutoComplete,
    watchOnEnter: watchOnEnter,
    watchOnSuggestionClick: watchOnSuggestionClick,
    watchOnKeywordUp: watchOnKeywordUp,
    watchOnKeywordDown: watchOnKeywordDown,
};
exports.megaSearchSagas = megaSearchSagas;
